import React from 'react';
import { BasicPageContainer } from "components/views/BasicPageContainer";
import { useTranslation } from 'react-i18next';

export const ResetPasswordErrorPage = () => {
    const { t } = useTranslation();

    return <BasicPageContainer>
        <div>{t('resetPasswordErrorPage.text')}</div>
    </BasicPageContainer>;
};